import { render, staticRenderFns } from "./SelectorColorChips.vue?vue&type=template&id=071b1b8b&"
import script from "./SelectorColorChips.vue?vue&type=script&lang=js&"
export * from "./SelectorColorChips.vue?vue&type=script&lang=js&"
import style0 from "./SelectorColorChips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('071b1b8b')) {
      api.createRecord('071b1b8b', component.options)
    } else {
      api.reload('071b1b8b', component.options)
    }
    module.hot.accept("./SelectorColorChips.vue?vue&type=template&id=071b1b8b&", function () {
      api.rerender('071b1b8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/selector/fragment/SelectorColorChips.vue"
export default component.exports